// extracted by mini-css-extract-plugin
module.exports = {"banner":"CategoryBanner_banner__2ADtJ","title":"CategoryBanner_title__2DD5h"};